import { useEffect, useState } from 'react';
import { canManageTeamMemberRoles } from './teamRoleUtils';

export function useOrgDetail(apiClient, orgId, userProfile) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!apiClient || !orgId) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError('');
    apiClient
      .get(`/api/organizations/${orgId}`)
      .then((res) => {
        if (!cancelled) setDetail(res.data || null);
      })
      .catch(() => {
        if (!cancelled) setError('Could not load team details.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [apiClient, orgId, userProfile?.roles]);

  return {
    detail,
    loading,
    error,
    canManageMemberRoles: canManageTeamMemberRoles(detail, userProfile),
  };
}
